import type { RechercheKnoten } from "../../services/firmendatenService";

/**
 * Den Rechercheergebnis-Baum zu einer eingerückten Liste flach klopfen.
 *
 * Bewusst ohne React und in einer eigenen Datei: Die Reihenfolge und die
 * Einrückung sind die eigentliche Auskunft des Ergebnisses („diese Gesellschaft
 * kam nur über jene dazu"), und genau das lässt sich hier prüfen.
 */
export interface BaumZeile {
  knoten: RechercheKnoten;
  /** 0 = Ausgangsname, 1 = daraus weitergesucht, … — steuert die Einrückung. */
  ebene: number;
}

export function baumZeilen(wurzel: RechercheKnoten | null | undefined): BaumZeile[] {
  if (!wurzel) return [];
  const zeilen: BaumZeile[] = [];
  const gehe = (k: RechercheKnoten, ebene: number) => {
    zeilen.push({ knoten: k, ebene });
    for (const kind of k.kinder ?? []) gehe(kind, ebene + 1);
  };
  gehe(wurzel, 0);
  return zeilen;
}
